import { Create, required, SelectInput, SimpleForm, useNotify, useRedirect } from "react-admin";
import { errorMessages } from "app";
import BackButtonToolbar from "features/BackButtonToolbar";
import { SectionTitle } from "features/SectionTitle";
import { DoctoralServicePath } from "utils/constants";
import PersonalInfoSection from "../ApprovedCandidacies/Enroll/PersonalInfoSection";
import NamesEnSection from "../ApprovedCandidacies/Enroll/NamesEnSection";
import BirthSection from "../ApprovedCandidacies/Enroll/BirthSection";
import PreviousEducationSection from "../ApprovedCandidacies/Enroll/PreviousEducationSection";
import TopicAndSupervisorsSection from "../ApprovedCandidacies/Enroll/TopicAndSupervisorsSection";
import ProgramStructureSection from "./Partials/ProgramStructureSection";
import { DoctoralSchoolPaymentProviderChoices } from "utils/choices";

const listPath = `/${DoctoralServicePath}doctorants`;

const toDateOnly = value => (value ? value.split("T")[0] : null);

const transform = form => ({
  doctoralProgramId: form.doctoralProgramId,
  departmentId: form.departmentId,
  structuralUnitId: form.structuralUnitId,
  instructionLanguageId: form.instructionLanguageId,
  topic: form.topic,
  orderNumber: form.orderNumber,
  orderDate: toDateOnly(form.orderDate),
  supervisorEmployeeIds: (form.supervisors ?? []).map(s => s?.employeeId).filter(Boolean),
  paymentProviderId: form.paymentProviderId,
  personId: form.personId,
  userInfo: {
    firstName: form.firstName,
    secondName: form.secondName,
    lastName: form.lastName,
    firstNameEn: form.firstNameEn,
    secondNameEn: form.secondNameEn,
    lastNameEn: form.lastNameEn,
    gender: form.gender,
    birthDate: toDateOnly(form.birthDate),
    birthCountryId: form.birthCountryId,
    birthSettlementId: form.birthSettlementId,
    birthSettlement: form.birthSettlement,
    contactPhone: form.contactPhone,
  },
  previousEducation: {
    ...form.previousEducation,
    diplomaDate: toDateOnly(form.previousEducation?.diplomaDate),
  },
});

const CreateDoctorant = () => {
  const notify = useNotify();
  const redirect = useRedirect();

  return (
    <Create
      title="Добавяне на докторант"
      transform={transform}
      mutationOptions={{
        onSuccess: () => {
          notify("Докторантът е добавен успешно", { type: "success" });
          redirect(listPath);
        },
        onError: err => {
          notify(err.message || errorMessages[err.errorCode] || errorMessages.default, { type: "error" });
        },
      }}
      actions={<BackButtonToolbar />}
    >
      <SimpleForm
        defaultValues={{
          previousEducation: {},
          topic: "",
          supervisors: [{ employeeId: null }],
        }}
      >
        <SectionTitle paddingY={2} title="Докторантска програма и структура" />
        <ProgramStructureSection />

        <SectionTitle paddingY={2} title="Лични данни" />
        <PersonalInfoSection />

        <SectionTitle paddingY={2} title="Имена (латиница)" />
        <NamesEnSection />

        <SectionTitle paddingY={2} title="Месторождение" />
        <BirthSection />

        <SectionTitle paddingY={2} title="Предходно образование" />
        <PreviousEducationSection />

        <SectionTitle paddingY={2} title="Докторантура" />
        <TopicAndSupervisorsSection />

        <SectionTitle paddingY={2} title="Плащане на годишната такса" />
        <SelectInput
          source="paymentProviderId"
          label="Начин на плащане"
          choices={DoctoralSchoolPaymentProviderChoices}
          sx={{ minWidth: 320 }}
          validate={required()}
        />
      </SimpleForm>
    </Create>
  );
};

export default CreateDoctorant;
